import { onboardingSlice } from "./onboardingSlice";
import * as actions from "./onboardingActions";
import * as selectors from "./onboardingSelectors";

export { actions };
export { selectors };
export default onboardingSlice.reducer;
